type ISizeComponent = {
  height: string;
  width: string;
};
type ISizePartialComponent = {
  height?: string;
  width?: string;
  margin?: string;
  borderRadius?: string;
};

type IIndents = {
  paddingLeft: string;
  paddingRight: string;
  paddingTop: string;
  paddingBottom: string;
  marginLeft: string;
  marginRight: string;
  marginTop: string;
  marginBottom: string;
};

type ISizesComponent = {
  mobile: ISizeComponent;
  tablet: ISizeComponent;
  notebook: ISizeComponent;
  desktop: ISizeComponent;
};
export type ISizesPartialComponent = {
  mobile?: ISizePartialComponent;
  tablet?: ISizePartialComponent;
  notebook?: ISizePartialComponent;
  desktop?: ISizePartialComponent;
};

type IIndentComponent = {
  mobile: IIndents;
  tablet: IIndents;
  notebook: IIndents;
  desktop: IIndents;
};

export const FooterSizes: ISizesComponent = {
  mobile: { height: '354px', width: '' },
  tablet: { height: '242px', width: '' },
  notebook: { height: '271px', width: '' },
  desktop: { height: '227px', width: '' },
};

export const HeaderSizes: ISizesComponent = {
  mobile: { height: '64px', width: '' },
  tablet: { height: '64px', width: '' },
  notebook: { height: '92px', width: '' },
  desktop: { height: '92px', width: '' },
};

export const MenuSizes: ISizesComponent = {
  mobile: { height: '', width: '' },
  tablet: { height: '', width: '' },
  notebook: { height: '', width: '314px' },
  desktop: { height: '', width: '314px' },
};

export const CardSaleSizes: ISizesComponent = {
  mobile: { height: '288px', width: '100%' },
  tablet: { height: '288px', width: 'calc(50% - 10px)' },
  notebook: { height: '288px', width: 'calc(50% - 10px)' },
  desktop: { height: '288px', width: 'calc(33% - 10px)' },
};

export const DiscountButton: ISizesComponent = {
  mobile: { height: '48px', width: '100%' },
  tablet: { height: '48px', width: '248px' },
  notebook: { height: '64px', width: '292px' },
  desktop: { height: '64px', width: '292px' },
};

export const MainIndents: IIndentComponent = {
  mobile: {
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '30px',
    paddingBottom: '100px',
    marginLeft: '',
    marginRight: '',
    marginTop: '',
    marginBottom: '',
  },
  tablet: {
    paddingLeft: '40px',
    paddingRight: '40px',
    paddingTop: '30px',
    paddingBottom: '100px',
    marginLeft: '',
    marginRight: '',
    marginTop: '',
    marginBottom: '',
  },
  notebook: {
    paddingLeft: '80px',
    paddingRight: '80px',
    paddingTop: '60px',
    paddingBottom: '150px',
    marginLeft: '',
    marginRight: '',
    marginTop: '',
    marginBottom: '',
  },
  desktop: {
    paddingLeft: '150px',
    paddingRight: '150px',
    paddingTop: '60px',
    paddingBottom: '150px',
    marginLeft: '',
    marginRight: '',
    marginTop: '',
    marginBottom: '',
  },
};

export const SelectIndents: IIndentComponent = {
  mobile: {
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: '12px',
    paddingBottom: '12px',
    marginLeft: '',
    marginRight: '',
    marginTop: '',
    marginBottom: '',
  },
  tablet: {
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: '12px',
    paddingBottom: '12px',
    marginLeft: '',
    marginRight: '',
    marginTop: '',
    marginBottom: '',
  },
  notebook: {
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: '12px',
    paddingBottom: '12px',
    marginLeft: '',
    marginRight: '',
    marginTop: '',
    marginBottom: '',
  },
  desktop: {
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: '12px',
    paddingBottom: '12px',
    marginLeft: '',
    marginRight: '',
    marginTop: '',
    marginBottom: '',
  },
};
